<template>
  <div class="public-content platform-sku">
    <div class="breadcrumb">模板日志</div>
    <div class="right-main" style="padding: 5px 10px;">
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column prop="id" label="编号"></el-table-column>
        <el-table-column prop="operation" label="操作项">
          <template slot-scope="scope"> {{ scope.row.operation === 'CREATE_GROUP' ? '创建模板' : scope.row.operation === 'AUDIT_GROUP' ? '审核模版' : scope.row.operation === 'ADD_TEMPLATE' ? '新加模版' :
            scope.row.operation === 'DELETE_GROUP' ? '删除模版' : scope.row.operation === 'UPDATE_GROUP' ? '更新模板' : scope.row.operation === 'DELETE_TEMPLATE' ? '移除模版' : scope.row.operation }} </template>
        </el-table-column>
        <el-table-column prop="createdName" label="操作人"></el-table-column>
        <el-table-column prop="createdTime" label="操作时间"></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { groupGetGroupOperationLog } from '@/api/pms'
export default {
  name: 'platform-sku',
  inject: ['reload'],
  data () {
    return {
      tableData: [],
      groupOperationLogVo: {
        createTimeBegin: '',
        createTimeEnd: '',
        createdName: '',
        groupId: this.$route.query.id,
        operation: '',
        page: 0
      }
    }
  },
  mounted () {
    sessionStorage.setItem('searchFlag', true)
  },
  created () {
    this.gettemplateLog()
  },
  methods: {
    gettemplateLog () {
      groupGetGroupOperationLog({ pageNum: 1, pageSize: 1, groupOperationLogVo: this.groupOperationLogVo }).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data.records
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
@import "index";
@deep: ~">>>";
</style>
